// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import ElementUI from 'element-ui';
import App from './App'
import router from './router'

import 'element-ui/lib/theme-chalk/index.css';
import store from './store/'
import './assets/css/mian.css'
import scroll from 'vue-seamless-scroll'
import WtDataArea from './components/dataArea/dataArea.js'
import WtDataTable from './components/dataTable/dataTable.js'
import VueTour from 'vue-tour'

require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour) //新手引导组件

import VueLazyload from 'vue-lazyload'

Vue.filter('setNumFormat', function (event, fixed = true, def = 0,) {
  //逻辑代码
  let data;
  if (fixed) {
    data = Number(event).toFixed(2);
  } else {
    data = Number(event);
  }
  if (data > 0) {
    return (data + "").replace(
      /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
      "$&,"
    );
  } else {
    return def;
  }
})

import Db from './api/db'
import fnc from './api/fnc'

let db = new Db()
Vue.use(db)
Vue.use(fnc)
Vue.use(VueLazyload)
// Vue.use(ElementUI)
Vue.use(WtDataArea)
Vue.use(WtDataTable)
Vue.use(store)

import {
  Button,
  Carousel,
  CarouselItem,
  Input,
  Select,
  Option,
  OptionGroup,
  Switch,
  Form,
  FormItem,
  Cascader,
  CheckboxGroup,
  Checkbox,
  RadioGroup,
  RadioButton,
  Radio,
  Row,
  Col,
  DatePicker,
  TimePicker,
  Progress,
  Pagination,
  Upload,
  Dialog,
  MessageBox,
  Message,
  Table,
  TableColumn,
  Steps,
  Step,
  InputNumber,
  ButtonGroup,
  Tabs,
  Tag,
  TabPane,
  Card,
  Icon,
  Tooltip,
  Popover,
  Alert,
  Loading,
  Drawer,
  collapse,
  CollapseItem,
  Divider
} from 'element-ui';

Vue.use(collapse)
Vue.use(CollapseItem)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Switch)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Cascader)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(RadioButton)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Button)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Progress)
Vue.use(Pagination)
Vue.use(Upload);
Vue.use(Steps)
Vue.use(Step)
Vue.use(InputNumber)
Vue.use(ButtonGroup)
Vue.use(Tabs)
Vue.use(Tag)
Vue.use(TabPane)
Vue.use(Card)
Vue.use(Icon)
Vue.use(Tooltip)
Vue.use(Popover)
Vue.use(Alert)
Vue.use(Loading)
// Vue.use(MessageBox);
// Vue.use(Message);
Vue.use(Drawer)
Vue.use(Divider)

store.dispatch('getWebInfo')
store.dispatch('getChannelInfo')

Vue.use(scroll)

// 引入moment.js工具
import moment from 'moment'
import '../static/UE/ueditor.config.js'
import '../static/UE/ueditor.all.js'
import '../static/UE/lang/zh-cn/zh-cn.js'
import '../static/UE/ueditor.parse.min.js'
Vue.prototype.$moment = moment


Vue.config.productionTip = false
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js